import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  title: "Mechanical resonator",
  descriptionHtml:
    "Play with the oscillator parameters to see their effect on the response curve. You can draw the admittance (V/F in m/N/s) or the impedance (F/V in N∙s/m) by clicking below.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0403/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
